import '../Styles/Login.css';
import PeiixMaster from '../img/Peiixmasterlogo.png';
import PeiixIsotipoBlanco from '../img/Peiix_isotipo_blanco.png'; // Nueva importación
import { Col, Row } from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Input, Spin } from 'antd';
import axios from 'axios';
import LoadingOverlay from './common/LoadingOverlay';

const Login = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false); // Nuevo estado para el modal
  const [loadingRegister, setLoadingRegister] = useState(false); // Transición a registro

  const navigate = useNavigate();

  const handleGoToRegister = (e) => {
    e.preventDefault();
    setLoadingRegister(true);
    setTimeout(() => {
      navigate('/Register');
    }, 700);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setMessage('Por favor complete ambos campos.');
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL_DEV + '/login';

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });
      if (response.status === 200) {
        const data = await response.json();
        localStorage.clear();

        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('user_role', data.role || data.rol);
        localStorage.setItem('is_account', data.is_account);
        localStorage.setItem('is_aggregator', data.is_aggregator);
        localStorage.setItem('cliente_id', data.cliente_id || data.ClienteID)
        localStorage.setItem('provider', data.provider)

        if (data.is_account === true) {
          if (data.is_aggregator === true) {

          } else {
            localStorage.setItem('id', data.id);
            localStorage.setItem('refresh_token', data.refresh_token);
            localStorage.setItem('bp_token', data.bp_token);
            localStorage.setItem('user_token', data.user_token);
            localStorage.setItem('nombre_comercial', data.nombre_comercial);
            localStorage.setItem('cliente_id', data.cliente_id || data.ClienteID);
            localStorage.setItem('provider', data.provider)

            localStorage.setItem('user_tokens_related', JSON.stringify(data.user_tokens_related));

            setMessage('Inicio de sesión exitoso!');

            // Redirigir según el rol
            if (data.rol === 'ADMIN') {
              navigate('/Master/Transacciones');
            } else if (data.rol === 'GERENTE' || data.rol === 'CAJERO' || data.role === 'USUARIO') {
              navigate('/Master/Transacciones');
            } else if (data.rol === 'CONTABILIDAD') {
              navigate('/Master/Depositos');
            } else {
              // Redirección por defecto si el rol no coincide
              navigate('/Master/Transacciones');
            }
          }
        } else { // is_account es false (Cuentita)
          let allBranchNames = [];
          if (data.trades && data.trades.length > 0) {
            // Guardar el nombre del trade como nombre_comercial
            if (data.trades[0].name) {
              localStorage.setItem('nombre_comercial', data.trades[0].name);
            }
            data.trades.forEach(trade => {
              if (trade.branches && trade.branches.length > 0) {
                trade.branches.forEach(branch => {
                  allBranchNames.push(branch.name);
                });
              }
            });
          }
          localStorage.setItem('cuentita_branches', JSON.stringify(allBranchNames));
          setMessage('Inicio de sesión exitoso!');
          // Redirigir según el rol
          if (data.role === 'ADMIN') {
            navigate('/Master/Transacciones');
          } else if (data.role === 'GERENTE' || data.role === 'CAJERO' || data.role === 'USUARIO') {
            navigate('/Master/Transacciones');
          } else if (data.role === 'CONTABILIDAD') {
            navigate('/Master/Depositos');
          } else {
            // Redirección por defecto si el rol no coincide
            navigate('/Master/Transacciones');
          }
        }
      } else if (response.status === 401) {
        setMessage('Usuario o contraseña incorrectos.');
      } else {

        setMessage('Error en el inicio de sesión. Por favor, intente de nuevo.', response.status);
      }
    } catch (error) {
      setMessage('Error al conectar con el servidor.');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div> {/* Contenedor padre agregado */}
      <div className="login-screen">
        <div className="isotipo-container"> {/* Nuevo contenedor para el isotipo */}
          <img
            className='isotipo-blanco' // Nueva clase para el isotipo
            src={PeiixIsotipoBlanco}
            alt="Peiix Isotipo Blanco"
          />
        </div>
        <div className="login">
          <div className="auth-form-container">
            <form className="login-form" onSubmit={handleSubmit}>
              <img
                className='logotipo'
                src={PeiixMaster}
                alt="Peiix Master"
              />
              <label className="inicio fw-bold">Inicio de sesión</label>
              <label className="email">Usuario o correo electrónico</label>
              <Input
                required
                type="email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Introduzca su correo"
                id="username"
                name="username"
                className="custom-email-input"
              />
              <label className="password">Contraseña</label>
              <Input.Password
                required
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Introduzca su contraseña"
                id="password"
                name="password"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                className="custom-password-input"
              />
              <br />
              <button className="btn fw-bold" type="submit">Acceder</button>
              <a href="/Register" onClick={handleGoToRegister} className="register-link">¿No tienes cuenta? Regístrate</a>
            </form>
            {message && <div className="mt-3 alert alert-info">{message}</div>}
          </div>
        </div>
      </div>

      {/* Loading Overlay hacia el Registro */}
      <LoadingOverlay show={loadingRegister} message="Cargando registro..." />

      {/* Modal de Bienvenida */}
      {showWelcomeModal && (
        <div className="welcome-modal-overlay">
          <div className="welcome-modal-content">
            <h2>¡Bienvenido!</h2>
            <p>Inicio de sesión exitoso.</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;